/**
 * data-bs-dismiss for dropdown-auto-close-outside
 */

export default (() => {
  document.addEventListener('click', function (e) {
    const dismissEl = e.target.closest('[data-bs-dismiss="dropdown"]')
    if (!dismissEl) return

    e.preventDefault()
    e.stopPropagation()

    // aria-labelledby
    const menu = dismissEl.closest('.dropdown-menu')
    if (menu) {
      const labelledby = menu.getAttribute('aria-labelledby')
      if (labelledby) {
        const toggle = document.getElementById(labelledby)
        if (toggle) {
          bootstrap.Dropdown.getOrCreateInstance(toggle).hide() // eslint-disable-line no-undef
          return
        }
      }
    }

    // fallback
    const root = dismissEl.closest(
      '.dropdown, .dropup, .dropstart, .dropend, .btn-group'
    )
    if (!root) return

    const toggles = root.querySelectorAll('[data-bs-toggle="dropdown"]')
    toggles.forEach((tg) => bootstrap.Dropdown.getOrCreateInstance(tg).hide()) // eslint-disable-line no-undef
  })
})()
